import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';
import { LayersSelectorComponent } from '@common-modules/wlm-map/components/layers-selector/layers-selector.component';
import { NgxSliderModule } from 'ngx-slider-v2';
import { CommonSharedModule } from '../shared/common-shared.module';
import { LayerItemComponent } from './components/layer-item/layer-item.component';
import { LayerTooltipComponent } from './components/layer-tooltip/layer-tooltip.component';
import { LayersGroupSelectorComponent } from './components/layers-group-selector/layers-group-selector.component';
import { MapTimeBarComponent } from './components/map-time-bar/map-time-bar.component';
import { MapTimeStepSliderComponent } from './components/map-time-step-slider/map-time-step-slider.component';
import { MapTopBarButtonsItemHostDirective } from './components/map-top-bar-buttons/map-top-bar-buttons-item-host.directive';
import { MapTopBarButtonsComponent } from './components/map-top-bar-buttons/map-top-bar-buttons.component';
import { MapSidePanelItemHostDirective } from './components/side-panel/map-side-panel-item-host.directive';
import { SidePanelComponent } from './components/side-panel/side-panel.component';
import { NewThematicPopupComponent } from './components/thematics/new-thematic-popup/new-thematic-popup.component';
import { ThematicsService } from './components/thematics/services/thematics.service';
import { ThematicConfiguratorPopupComponent } from './components/thematics/thematic-configurator-popup/thematic-configurator-popup.component';
import { TimelineSliderComponent } from './components/timeline-slider/timeline-slider.component';
import { GenericMapComponent } from './generic-map/generic-map/generic-map.component';
import { BaseLayerItemService } from './generic-map/services/base-layer-item.service';
import { BaseLayerProviderService } from './generic-map/services/base-layer-provider.service';
import { GenericMapStylesService } from './generic-map/services/generic-map-styles.service';
import { GenericMapService } from './generic-map/services/generic-map.service';
import { GeoserverLayerProviderService } from './generic-map/services/geoserver-layer-provider.service';
import { LayerItemManagerService } from './generic-map/services/layer-item-manager.service';
import { LeafletMapComponent } from './leaflet-map/leaflet-map.component';
import { MapModuleSettings } from './map-module-settings';
import { LayerIconPipe } from './pipes/layer-icon.pipe';
import { ExportedMapParamsService } from './services/exported-map-params.service';
import { FeatureInfoService } from './services/feature-info.service';
import { LayerService } from './services/layers.service';
import { LeafletBetterWmsService } from './services/leaflet-better-wms.service';
import { LeafletTimeBarService } from './services/leaflet-time-bar.service';
import { VelocitySelectorComponent } from './velocity-selector/velocity-selector.component';

@NgModule({
  declarations: [
    LeafletMapComponent,
    LayersSelectorComponent,
    SidePanelComponent,
    LayerItemComponent,
    LayerTooltipComponent,
    MapSidePanelItemHostDirective,
    MapTimeBarComponent,
    MapTimeStepSliderComponent,
    LayersGroupSelectorComponent,
    LayerIconPipe,
    MapTopBarButtonsComponent,
    MapTopBarButtonsItemHostDirective,
    VelocitySelectorComponent,
    GenericMapComponent,
    NewThematicPopupComponent,
    ThematicConfiguratorPopupComponent,
    TimelineSliderComponent,
  ],
  imports: [CommonModule, CommonSharedModule, NgxSliderModule, MatSliderModule],
  exports: [LeafletMapComponent, GenericMapComponent],
  providers: [
    LeafletBetterWmsService,
    FeatureInfoService,
    LayerService,
    LeafletTimeBarService,
    ExportedMapParamsService,
    GeoserverLayerProviderService,
    GenericMapService,
    LayerItemManagerService,
    GenericMapStylesService,
    {
      provide: BaseLayerProviderService,
      useExisting: GeoserverLayerProviderService,
      multi: true,
    },

    ThematicsService,
    { provide: 'ThematicsService', useExisting: ThematicsService },
  ],
})
export class WlmMapModule {
  static forFeature(settings?: MapModuleSettings): ModuleWithProviders<WlmMapModule> {
    const providers: Provider[] = [];
    if (settings?.layerItemServices) {
      settings.layerItemServices.forEach((service) => {
        providers.push({
          provide: BaseLayerItemService,
          useClass: service,
          multi: true,
        });
      });
    }

    return {
      ngModule: WlmMapModule,
      providers,
    };
  }
}
